const STORAGE_KEY = "kiwi_accessibility_settings";

export const saveSettings = (settings) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error("Unable to save accessibility settings.", error);
  }
};

export const loadSettings = () => {
  try {
    const settings = localStorage.getItem(STORAGE_KEY);

    return settings ? JSON.parse(settings) : null;
  } catch (error) {
    console.error("Unable to load accessibility settings.", error);
    return null;
  }
};

export const clearSettings = () => {
  localStorage.removeItem(STORAGE_KEY);
};